module.exports = __webpack_public_path__ + "img/f-logo.68e2ccce.png";